// Simple function to hide links using wlm.arrHideLinks
function hideLinksWithCSS() {
    if (!window.wlm || !window.wlm.arrHideLinks || window.wlm.arrHideLinks.length === 0) {
        return;
    }

    // Create or get style element
    let styleElement = document.getElementById('wlm-hide-links-style');
    if (!styleElement) {
        styleElement = document.createElement('style');
        styleElement.id = 'wlm-hide-links-style';
        document.head.appendChild(styleElement);
    }

    // Build CSS from array
    let cssRules = '';
    window.wlm.arrHideLinks.forEach(function(selector) {
        cssRules += selector + ' { display: none !important; }\n';
    });

    styleElement.innerHTML = cssRules;
}

// Run the function
hideLinksWithCSS();